import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyIsSetPipe } from './key-is-set.pipe';



@NgModule({
    declarations: [KeyIsSetPipe],
    exports: [KeyIsSetPipe],
    imports: [
        CommonModule
    ]
})
export class KeyIsSetModule { }
